import { consultarInscritosOCM, descargarExcelOCM, enviarOCM } from "../services/serviceOcm";

export function UseConsultaOCM() {
    const getInscritos = async (estado: string) => {
        const response = await consultarInscritosOCM(estado);
        return response;
    }

    const descargarExcel = async () => {
        const response = await descargarExcelOCM();
        return response;
    }

    const enviarExcelOCM = async() => {
        const response = await enviarOCM();
        return response;
    }

    return{
        getInscritos,
        descargarExcel,
        enviarExcelOCM
    }
}